import { render, staticRenderFns } from "./ModalMinhasSolicitacoes.vue?vue&type=template&id=79276d27&scoped=true"
import script from "./ModalMinhasSolicitacoes.vue?vue&type=script&lang=js"
export * from "./ModalMinhasSolicitacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalMinhasSolicitacoes.vue?vue&type=style&index=0&id=79276d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79276d27",
  null
  
)

export default component.exports